var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormRightTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 66,
    viewBox: "0 0 41 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8508 6.49535C34.0583 15.4915 30.9745 32.643 6.89983 33.4461C6.62169 24.4501 11.4712 7.29243 33.8508 6.49535Z",
    fill: "#00487A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9016 33.0496C15.8977 32.8421 33.0493 35.9259 33.8523 60.0006C24.8564 60.2787 7.69868 55.4292 6.9016 33.0496Z",
    fill: "#00487A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormRightTop);
export default __webpack_public_path__ + "static/media/formRightTop.c03aeadd1d7711304351c8929bb3d09e.svg";
export { ForwardRef as ReactComponent };